module.exports = __webpack_public_path__ + "static/media/nps-2018-master.004fcc88.csv";